var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#240201",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 21L3.42414 20.8315C3.37108 21.0129 3.40655 21.2086 3.51985 21.3598C3.63315 21.511 3.81106 21.6 4 21.6V21ZM20 21V21.6C20.1889 21.6 20.3668 21.511 20.4802 21.3598C20.5935 21.2086 20.6289 21.0129 20.5759 20.8315L20 21ZM15.8444 7.5C15.8444 9.66096 14.1162 11.4 12 11.4V12.6C14.793 12.6 17.0444 10.3096 17.0444 7.5H15.8444ZM12 11.4C9.88378 11.4 8.15556 9.66096 8.15556 7.5H6.95556C6.95556 10.3096 9.20703 12.6 12 12.6V11.4ZM8.15556 7.5C8.15556 5.33904 9.88378 3.6 12 3.6V2.4C9.20703 2.4 6.95556 4.6904 6.95556 7.5H8.15556ZM12 3.6C14.1162 3.6 15.8444 5.33904 15.8444 7.5H17.0444C17.0444 4.6904 14.793 2.4 12 2.4V3.6ZM4.57586 21.1685C5.57852 17.7415 8.54382 15.3 12 15.3V14.1C7.94824 14.1 4.55811 16.9557 3.42414 20.8315L4.57586 21.1685ZM12 15.3C15.4562 15.3 18.4215 17.7415 19.4241 21.1685L20.5759 20.8315C19.4419 16.9557 16.0518 14.1 12 14.1V15.3ZM4 21.6H20V20.4H4V21.6Z",
    fill: ""
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUser);
export default __webpack_public_path__ + "static/media/icon-user.3b48c8a0bf4965699de4900f5616d0e3.svg";
export { ForwardRef as ReactComponent };